import { mdiNewspaperVariant, mdiNewspaperVariantOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const Newspaper = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Newspaper"
            path={filled ? mdiNewspaperVariant : mdiNewspaperVariantOutline}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Newspaper
